import { useEffect, useState } from "react";

export default function Loader(props) {
    return (
        <div className='loader' />
    );
}